import React from "react";
import NoteEditor from "./NoteEditor";

const NoteEditorField = (props) => {
  const {
    meta: { touched, error },
    input,
  } = props;
  return (
    <div>
      {" "}
      <NoteEditor
        onChange={input.onChange}
        value={input.value}
        touched={touched}
        error={error}
        input={{ ...input }}
      />
    </div>
  );
};

export default NoteEditorField;
